import { ForecastWorkspace } from '@/components/forecast/workspace/ForecastWorkspace';

export default function Forecast() {
  return <ForecastWorkspace />;
}